import React, { Component } from "react";

export default class TimeLine extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="m-3">
        <div className="row bg-dark text-light">
          <h2>Events</h2>
        </div>
        <div className="row">Some text will be here</div>
      </div>
    );
  }
}
